import { Field } from 'formik'

import FormikSelectField from '@components/form/FormikSelectField'

import { loanPurposeOptions } from '@config/loanPurposeOptions'

const FormikLoanPurposeSelect = () => (
    <Field
        component={FormikSelectField}
        labelText="What is the loan for?"
        name="loanPurpose"
        options={loanPurposeOptions}
    />
)

export default FormikLoanPurposeSelect
